import type { FC } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Hidden, IconButton, Toolbar } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { AppBarProps } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import AccountPopover from '../../molecules/Navbar/AccountPopover';
import LanguagePopover from '../../molecules/Navbar/LanguagePopover';
import DiapasonLogo from '../../atoms/DiapasonLogo';

interface DiapasonNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
}

const DiapasonNavbarRoot = experimentalStyled(AppBar)(
  ({ theme }) => (
    {
      ...(
        theme.palette.mode === 'light' && {
          backgroundColor: theme.palette.primary.main,
          boxShadow: 'none',
          color: theme.palette.primary.contrastText
        }
      ),
      ...(
        theme.palette.mode === 'dark' && {
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxShadow: 'none'
        }
      ),
      zIndex: theme.zIndex.drawer + 100
    }
  )
);

const DiapasonNavbar: FC<DiapasonNavbarProps> = (props) => {
  const { onSidebarMobileOpen, ...other } = props;

  return (
    <DiapasonNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarMobileOpen}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          <DiapasonLogo textColor="text-white" />
        </Hidden>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        <LanguagePopover />
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DiapasonNavbarRoot>
  );
};

DiapasonNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DiapasonNavbar;
